/**
 * Service: sfdcApi
 */

angular.module('acme.common.service.sfdcApi', [
    'acme.common.factory.apiVersion',
    'acme.common.factory.QueryStringBuilder'
])
.service('SfdcApiService', ['$http', 'ApiVersionFactory', 'QueryStringBuilderFactory', function($http, ApiVersionFactory, QueryStringBuilderFactory) {
    return {

        service: '',

        init: function(endpoint) {

            this.service = endpoint + '/integration';

            this.order.service = endpoint + '/integration/sfdc/search/order';
            this.membership.service = endpoint + '/integration/sfdc/search/membership';
            this.customer.service = endpoint + '/integration/sfdc/search/customer';
            this.logs.service = endpoint + '/integration/request-logs';
            // this.contact.service =  endpoint + '/integration/sfdc/search/contact';
            // this.organization.service = endpoint + '/integration/sfdc/search/organization';
            // this.household.service = endpoint + '/integration/sfdc/search/household';

            return this;
        },

        pushData: function(props) {
            var av = new ApiVersionFactory(),
                q = '',
                type = '';

            if (props) {
                var qs = new QueryStringBuilderFactory({
                    props: props,
                    fields: {
                    optional: ['tenantId']
                    }
                });
                q = qs.query;

                type = ((props.objectType === 'orders') ? 'visitation/' : '') + props.objectType;
            }

            return $http({
                method: 'post',
                url: av.init({url: this.service + '/' + type + '/' + props.acmeId + q, version: 'v2'})
            });
        },

        order: {
            service: '',

            detail: function(id) {
                var av= new ApiVersionFactory();

                return $http({
                    method: 'get',
                    url: av.init({url: this.service + '/' + id, version: 'v2'})
                });
            }

        },

        membership: {
            service: '',

            detail: function(id) {
                var av= new ApiVersionFactory();

                return $http({
                    method: 'get',
                    url: av.init({url: this.service + '/' + id, version: 'v2'})
                });
            }
        },

        customer: {
            service: '',

            detail: function(id) {
                var av= new ApiVersionFactory();

                return $http({
                    method: 'get',
                    url: av.init({url: this.service + '/' + id, version: 'v2'})
                });
            }
        },

        logs: {
            service: '',

            get: function(id) {
                var av = new ApiVersionFactory();

                return $http({
                    method: 'get',
                    url: av.init({
                        url: this.service + '/' +  id,
                        version: 'v2'
                      }),
                  });
            },

            list: function(props) {
                var q = '',
                    av = new ApiVersionFactory();

                if (props) {
                  var qs = new QueryStringBuilderFactory({
                    props: props,
                    fields: {
                      optional: ['operation', 'target', 'objectId', 'pageSize', 'page', 'sortField', 'sortDirection', 'search']
                    }
                  });
                  q = qs.query;
                }

                return $http({
                    method: 'get',
                    url: av.init({
                        url: this.service + '/search' +  q,
                        version: 'v2'
                      }),
                  });
            }
        }
    };
}]);